export enum CookieKey {
    LanguageCodePreference = 'languageCodePreference',
    LanguageSuggestionBanner = 'languageSuggestionBannerOff',
    AdminUserInfoKey = 'adminUserInfo',
    CookiePolicyKey = 'cookiePolicyAccepted',
}
